
/*
 * LIFE UPGRADE
 * Shopify Attribution Bridge v2.0
 *
 * GA4 + Google Ads + UTM
 * Storefront -> Data Layer + Shopify Cart
 *
 * Nie instaluje GTM.
 * Nie wysyla eventow ecommerce.
 * Respektuje zgody Shopify.
 */

(function () {
  'use strict';

  if (window.__luAttributionBridgeV2) return;
  window.__luAttributionBridgeV2 = true;

  var GA4_ID = 'H1BBR87XGG';
  var TTL = 30 * 24 * 60 * 60 * 1000;

  var GA_KEYS = [
    'ga_client_id',
    'ga_session_id',
    'ga_session_number',
    'ga4_cookie_name'
  ];

  var AD_KEYS = [
    'gclid',
    'gbraid',
    'wbraid'
  ];

  var UTM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_id',
    'utm_content',
    'utm_term'
  ];

  var MARKETING_KEYS = AD_KEYS.concat(
    ['_lu_ads_click_ts'],
    UTM_KEYS,
    ['_lu_utm_ts']
  );

  var ALL_KEYS = GA_KEYS.concat(MARKETING_KEYS);

  var started = false;
  var running = false;
  var rerun = false;
  var timer = null;
  var lastPublished = '';

  window.dataLayer = window.dataLayer || [];

  // -----------------------------------------
  // COOKIES
  // -----------------------------------------

  function cookie(name) {
    var parts = document.cookie.split(';');
    var prefix = name + '=';

    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();

      if (part.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(
            part.slice(prefix.length)
          );
        } catch (e) {
          return '';
        }
      }
    }

    return '';
  }

  // -----------------------------------------
  // ZGODY SHOPIFY
  // -----------------------------------------

  function privacy() {
    var cp = window.Shopify &&
      window.Shopify.customerPrivacy;

    if (
      !cp ||
      typeof cp.analyticsProcessingAllowed !== 'function' ||
      typeof cp.marketingAllowed !== 'function'
    ) {
      return null;
    }

    return {
      analytics: cp.analyticsProcessingAllowed() === true,
      marketing: cp.marketingAllowed() === true
    };
  }

  // -----------------------------------------
  // GA4 CLIENT ID
  // -----------------------------------------

  function gaClientId() {
    var match = cookie('_ga').match(
      /^GA\d+\.\d+\.(\d+\.\d+)$/
    );

    return match ? match[1] : '';
  }

  // -----------------------------------------
  // GA4 SESSION
  // -----------------------------------------

  function gaSession() {
    var value = cookie('_ga_' + GA4_ID);

    var result = {
      id: '',
      number: ''
    };

    if (value.indexOf('GS2.') === 0) {
      var sid = value.match(
        /(?:GS2\.\d+\.|\$)s(\d+)/
      );

      var sn = value.match(
        /(?:GS2\.\d+\.|\$)o(\d+)/
      );

      result.id = sid ? sid[1] : '';
      result.number = sn ? sn[1] : '';

    } else if (value.indexOf('GS1.') === 0) {
      var parts = value.split('.');

      result.id = parts[2] || '';
      result.number = parts[3] || '';
    }

    return result;
  }

  // -----------------------------------------
  // PARAMETRY KAMPANII
  // -----------------------------------------

  function params() {
    return new URLSearchParams(
      window.location.search
    );
  }

  function validClick(value) {
    return (
      typeof value === 'string' &&
      value.length > 0 &&
      value.length <= 500 &&
      /^[A-Za-z0-9._~+/=%-]+$/.test(value)
    );
  }

  function validTime(timestamp) {
    if (!timestamp) return false;

    var n = Number(timestamp);
    var age = Date.now() - n;

    return Number.isFinite(n) &&
      age >= 0 &&
      age <= TTL;
  }

  function gclidCookie() {
    var match = cookie('_gcl_aw').match(
      /^GCL\.(\d+)\.(.+)$/
    );

    if (!match || !validClick(match[2])) {
      return null;
    }

    var timestamp = Number(match[1]) * 1000;

    if (!validTime(timestamp)) return null;

    return {
      value: match[2],
      timestamp: timestamp
    };
  }

  // -----------------------------------------
  // BUDOWANIE DANYCH
  // -----------------------------------------

  function build(existing, consent) {
    var result = {};
    var query = params();

    ALL_KEYS.forEach(function (key) {
      result[key] = String(existing[key] || '');
    });

    // GA4: aktualne cookies, nie stare ID.
    if (consent.analytics) {
      var cid = gaClientId();
      var session = gaSession();

      result.ga_client_id = cid || '';
      result.ga_session_id = session.id || '';
      result.ga_session_number = session.number || '';

      result.ga4_cookie_name =
        cid && session.id && session.number
          ? '_ga_' + GA4_ID
          : '';

    } else {
      GA_KEYS.forEach(function (key) {
        result[key] = '';
      });
    }

    // Marketing: usun dane bez zgody.
    if (!consent.marketing) {
      MARKETING_KEYS.forEach(function (key) {
        result[key] = '';
      });

      return result;
    }

    // Wygasniecie starych identyfikatorow.
    if (!validTime(result._lu_ads_click_ts)) {
      AD_KEYS.forEach(function (key) {
        result[key] = '';
      });

      result._lu_ads_click_ts = '';
    }

    if (!validTime(result._lu_utm_ts)) {
      UTM_KEYS.forEach(function (key) {
        result[key] = '';
      });

      result._lu_utm_ts = '';
    }

    // Google Ads: rzeczywiste ID z URL.
    var urlHasClick = AD_KEYS.some(function (key) {
      return validClick(query.get(key));
    });

    if (urlHasClick) {
      var changedClick = AD_KEYS.some(function (key) {
        var value = query.get(key);

        return result[key] !== (
          validClick(value) ? value : ''
        );
      });

      if (
        changedClick ||
        !validTime(result._lu_ads_click_ts)
      ) {
        AD_KEYS.forEach(function (key) {
          var value = query.get(key);

          result[key] = validClick(value)
            ? value
            : '';
        });

        result._lu_ads_click_ts =
          String(Date.now());
      }

    } else {
      // Fallback gclid z cookie Google Ads.
      var fromCookie = gclidCookie();

      if (
        fromCookie &&
        (
          !validTime(result._lu_ads_click_ts) ||
          fromCookie.timestamp >
            Number(result._lu_ads_click_ts)
        )
      ) {
        result.gclid = fromCookie.value;
        result.gbraid = '';
        result.wbraid = '';

        result._lu_ads_click_ts =
          String(fromCookie.timestamp);
      }
    }

    // UTM: zapisz nowe wejscie kampanii.
    var hasUtm = UTM_KEYS.some(function (key) {
      return query.has(key);
    });

    if (hasUtm) {
      var changedUtm = UTM_KEYS.some(function (key) {
        var value = (query.get(key) || '').slice(
          0, 300
        );

        return result[key] !== value;
      });

      if (
        changedUtm ||
        !validTime(result._lu_utm_ts)
      ) {
        UTM_KEYS.forEach(function (key) {
          result[key] = (
            query.get(key) || ''
          ).slice(0, 300);
        });

        result._lu_utm_ts =
          String(Date.now());
      }
    }

    return result;
  }

  // -----------------------------------------
  // DATA LAYER
  // -----------------------------------------

  function publish(data) {
    var payload = {};

    ALL_KEYS.forEach(function (key) {
      // null usuwa stara wartosc ze stanu GTM.
      payload[key] = data[key] || null;
    });

    var signature = JSON.stringify(payload);

    if (signature === lastPublished) return;

    lastPublished = signature;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  // -----------------------------------------
  // SHOPIFY CART API
  // -----------------------------------------

  function cartUrl(path) {
    var root = (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';

    return root.replace(/\/?$/, '/') + path;
  }

  async function sync() {
    if (running) {
      rerun = true;
      return;
    }

    var consent = privacy();

    if (!consent) return;

    running = true;

    try {
      var response = await fetch(
        cartUrl('cart.js'),
        {
          credentials: 'same-origin',
          cache: 'no-store'
        }
      );

      if (!response.ok) {
        throw new Error(
          'Cart GET HTTP ' + response.status
        );
      }

      var cart = await response.json();

      var existing = cart.attributes || {};

      var data = build(existing, consent);

      var currentConsent = privacy();

      if (
        !currentConsent ||
        currentConsent.analytics !== consent.analytics ||
        currentConsent.marketing !== consent.marketing
      ) {
        rerun = true;
        return;
      }

      // Udostepnij GA4 i kampanie w Data Layer.
      publish(data);

      // Shopify: aktualizuj tylko zmienione pola.
      var changes = {};

      ALL_KEYS.forEach(function (key) {
        var oldValue = String(existing[key] || '');
        var newValue = data[key] || '';

        if (oldValue !== newValue) {
          changes[key] = newValue;
        }
      });

      if (Object.keys(changes).length === 0) {
        return;
      }

      var update = await fetch(
        cartUrl('cart/update.js'),
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: changes
          })
        }
      );

      if (!update.ok) {
        throw new Error(
          'Cart POST HTTP ' + update.status
        );
      }

    } catch (error) {
      console.warn(
        '[LU Attribution v2]',
        error.message
      );

    } finally {
      running = false;

      if (rerun) {
        rerun = false;
        schedule();
      }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  // GA4 do Data Layer bez czekania na cart.js.
  function publishCurrentGa() {
    var consent = privacy();

    if (!consent) return;

    var data = {};

    ALL_KEYS.forEach(function (key) {
      data[key] = '';
    });

    if (consent.analytics) {
      var cid = gaClientId();
      var session = gaSession();

      data.ga_client_id = cid;
      data.ga_session_id = session.id;
      data.ga_session_number = session.number;

      if (cid && session.id && session.number) {
        data.ga4_cookie_name =
          '_ga_' + GA4_ID;
      }
    }

    // Nie kasuj tu historii kampanii.
    // Pelna synchronizacja pobierze ja z cart.js.
    if (consent.analytics && data.ga_client_id) {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        ga_client_id: data.ga_client_id,
        ga_session_id: data.ga_session_id || null,
        ga_session_number:
          data.ga_session_number || null,
        ga4_cookie_name:
          data.ga4_cookie_name || null
      });
    }
  }

  // -----------------------------------------
  // START
  // -----------------------------------------

  function start() {
    if (started) return;
    started = true;

    publishCurrentGa();
    schedule();

    setTimeout(schedule, 3000);
    setTimeout(schedule, 10000);

    document.addEventListener(
      'visitorConsentCollected',
      function () {
        schedule();
      }
    );

    window.addEventListener(
      'pageshow',
      schedule
    );

    document.addEventListener(
      'visibilitychange',
      function () {
        if (!document.hidden) schedule();
      }
    );

    window.addEventListener(
      'popstate',
      schedule
    );

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;

        if (
          target &&
          target.closest &&
          target.closest('a[href]')
        ) {
          schedule();
        }
      },
      true
    );
  }

  var featureRequested = false;

  function initialise() {
    if (started) return;

    if (privacy() !== null) {
      start();
      return;
    }

    if (
      !featureRequested &&
      window.Shopify &&
      typeof window.Shopify.loadFeatures ===
        'function'
    ) {
      featureRequested = true;

      window.Shopify.loadFeatures(
        [{
          name: 'consent-tracking-api',
          version: '0.2'
        }],
        function (error) {
          if (error) {
            featureRequested = false;
          }

          if (privacy() !== null) start();
        }
      );
    }
  }

  initialise();

  window.addEventListener(
    'load',
    initialise
  );

  var attempts = 0;

  var interval = setInterval(function () {
    if (started || attempts >= 30) {
      clearInterval(interval);
      return;
    }

    attempts++;
    initialise();
  }, 1000);

})();
